/* Delegated events survive theme editor section replacements without duplicate listeners. */
(() => {
  if (window.megaHomeReady) return;
  window.megaHomeReady = true;
  let fullHeight = 0;
  let menuHeight = 0;
  const updateHeaderScroll = () => {
    const header = document.querySelector('.mega-header-section header');
    const menu = header?.lastElementChild;
    if (!header || !menu) return;
    const focusAboveMenu = header.contains(document.activeElement) && !menu.contains(document.activeElement);
    const collapsed = header.classList.contains('mega-header-compact');
    const threshold = collapsed ? 32 : Math.max(64, fullHeight - menuHeight);
    const compact = !focusAboveMenu && window.scrollY > threshold;
    header.classList.toggle('mega-header-compact', compact);
    document.body.style.setProperty('--mega-header-height', `${compact ? menuHeight : fullHeight}px`);
  };
  const sizeHeader = () => {
    const header = document.querySelector('.mega-header-section header');
    const main = document.getElementById('MainContent');
    if (header && main) {
      fullHeight = Math.ceil(header.getBoundingClientRect().height);
      menuHeight = Math.ceil(header.lastElementChild?.getBoundingClientRect().height || fullHeight);
      // Keep document spacing stable; only the fixed header moves out of view.
      main.style.paddingTop = `${fullHeight}px`;
      header.style.setProperty('--mega-header-collapse', `${Math.max(0, fullHeight - menuHeight)}px`);
      updateHeaderScroll();
    }
  };
  let observer;
  const observeHeader = () => {
    observer?.disconnect();
    const header = document.querySelector('.mega-header-section header');
    if (header && 'ResizeObserver' in window) {
      observer = new ResizeObserver(sizeHeader);
      observer.observe(header);
    }
    sizeHeader();
    // The native drawer binds once. Rebind only when the editor replaces the header.
    const cart = document.getElementById('cart-icon-bubble');
    if (cart && window.customElements.get('cart-drawer') && !cart.hasAttribute('aria-haspopup')) {
      document.querySelector('cart-drawer')?.setHeaderCartIconAccessibility();
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mega-scroll]');
    if (button) {
      const track = button.parentElement.querySelector('[data-mega-track]');
      track?.scrollBy({left: Number(button.dataset.megaScroll) * 280, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    document.querySelectorAll('.mega-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.mega-menu[open]').forEach(menu => {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
    }
  });
  document.addEventListener('shopify:section:load', observeHeader);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(observeHeader));
  window.addEventListener('resize', sizeHeader, {passive:true});
  let scrollPending = false;
  window.addEventListener('scroll', () => {
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(() => {
      scrollPending = false;
      updateHeaderScroll();
    });
  }, {passive:true});
  document.addEventListener('focusin', updateHeaderScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeHeader, {once:true});
  else observeHeader();
})();
